import React from 'react';

// A box with the height of a chart, in place of the chart: the empty text, an error, a note.
// A dashed light border keeps the place of the chart, so the page does not jump.
// LineChart, BarChart and ChartCard use it. The caller gives the text and the height.
type Props = {
	// The height of the chart that the box replaces, in px (CHART_HEIGHT).
	height: number,
	// The name of the chart for a screen reader.
	ariaLabel?: string,
	children: React.ReactNode,
};

const ChartMessage: React.FunctionComponent<Props> = ({ height, ariaLabel, children }) =>
	<div role={ariaLabel === undefined ? undefined : 'img'} aria-label={ariaLabel} style={{ height }}
		className="flex w-full flex-col items-center justify-center gap-y-3 rounded-md border border-dashed border-gray-200 px-4 text-center text-sm text-gray-500">
		{children}
	</div>;

export default ChartMessage;
